import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface SepticSewerProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const SepticSewer: React.FC<SepticSewerProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [septicSewer, set_septicSewer] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Septic/Sewer'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Septic/Sewer': v } } })
    );
    const label = 'Septic/Sewer';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(septicSewer)}
                />
            ) : (
                <MoneyBox
                    id={'septicSewer'}
                    allowNegative={false}
                    value={septicSewer}
                    onChange={(value) => set_septicSewer(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
